import type { Option } from "@sorcery/db";
import {
  CardRarityEnum,
  CardTypeEnum,
  CollectionItemConditionEnum,
  ComparitorEnum,
  ComparitorFilterTypeEnum,
  DeckFormatEnum,
  DeckVisibilityEnum,
  ElementEnum,
  FilterTypeEnum,
  KeywordEnum,
  SubtypeEnum,
  VariantFinishEnum,
} from "@sorcery/db";

import { CardSortEnum } from "~/types/card";
import { DeckSortEnum } from "~/types/deck";

// when searching and sorting...
export const SEARCH_SORT = "relevance" as const;
export const SEARCH_SORT_OPTION: Option = {
  label: "Best Match",
  value: SEARCH_SORT,
};

export const cardSortOptions: Option[] = [SEARCH_SORT_OPTION].concat(
  Object.values(CardSortEnum).map((v) => ({
    label: v.charAt(0).toUpperCase() + v.slice(1),
    value: v,
  })),
);
export const conditionOptions: Option[] = Object.values(CollectionItemConditionEnum).map((v) => ({
  label: v,
  value: v,
}));
export const deckSortOptions: Option[] = [SEARCH_SORT_OPTION].concat(
  Object.values(DeckSortEnum).map((v) => ({
    label: v.charAt(0).toUpperCase() + v.slice(1),
    value: v,
  })),
);

export const formatOptions: Option[] = Object.values(DeckFormatEnum).map((v) => ({
  label: v,
  value: v,
  type: FilterTypeEnum.FORMAT,
}));

// skip none type
export const typeFilterOptions: Option[] = Object.values(CardTypeEnum)
  .filter((v) => v !== CardTypeEnum.None)
  .map((v) => ({
    label: v,
    value: v,
    type: FilterTypeEnum.TYPE,
  }));
export const elementOptions: Option[] = Object.values(ElementEnum).map((v) => ({
  label: v,
  value: v,
  type: FilterTypeEnum.ELEMENT,
}));
export const reducedElementOptions = elementOptions.filter((e) => e.value !== ElementEnum.None);
export const finishOptions: Option[] = Object.values(VariantFinishEnum).map((v) => ({
  label: v,
  value: v,
  type: FilterTypeEnum.FINISH,
}));
// skip none rarity
export const rarityFilterOptions: Option[] = Object.values(CardRarityEnum)
  .filter((v) => v !== CardRarityEnum.None)
  .map((v) => ({
    label: v,
    value: v,
    type: FilterTypeEnum.RARITY,
  }));
export const subtypeOptions: Option[] = Object.values(SubtypeEnum).map((v) => ({
  label: v,
  value: v,
  type: FilterTypeEnum.SUBTYPE,
}));
export const keywordOptions: Option[] = Object.values(KeywordEnum).map((v) => ({
  label: v,
  value: v,
  type: FilterTypeEnum.KEYWORD,
}));
// export const artistOptions: Option[] = artists
//   .map((v) => ({
//     label: v,
//     value: v,
//     type: FilterTypeEnum.ARTIST,
//   }))
//   .sort((a, b) => a.label.localeCompare(b.label));

export const thresholdOptions: Option[] = [
  {
    label: "Any",
    value: "*",
    type: ComparitorFilterTypeEnum.THRESHOLD,
    comparitor: undefined,
    target: undefined,
  },
].concat(
  Object.values(ElementEnum)
    // skip none type, doesnt make sense to filter on 'none elemental threshold of x amount'
    .filter((t) => t !== ElementEnum.None)
    .map((v) => ({
      label: v,
      value: v, // the element
      type: ComparitorFilterTypeEnum.THRESHOLD,
      comparitor: undefined, // the comparitor
      target: undefined, // the number to compare against
    })),
);

export const comparitorOptions: Option[] = [
  { label: "Equals", value: ComparitorEnum.EQUALS },
  { label: "Less than", value: ComparitorEnum.LESSTHAN },
  { label: "Greater than", value: ComparitorEnum.GREATERTHAN },
];

export const deckFormatOptions: Option[] = Object.values(DeckFormatEnum).map((v) => ({
  label: v,
  value: v,
}));

export const visibilityOptions: Option[] = [
  {
    label: "Any",
    value: "*",
  },
].concat(
  Object.values(DeckVisibilityEnum).map((v) => ({
    label: v.charAt(0).toUpperCase() + v.slice(1),
    value: v,
  })),
);
